export const iconFontAwesomeHumanitarianPlugCircleBolt = (
	<i className="fa-solid fa-plug-circle-bolt"></i>
);
